"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateWebpackDEV = void 0;
var helpers_1 = require("../../../helpers");
var main_1 = require("../../../main");
var webpack_common_1 = require("./webpack.common");
function generateWebpackDEV(options, deps) {
    return __awaiter(this, void 0, void 0, function () {
        var ENV_CONFIG, ModuleFederationPlugin, HtmlWebpackPlugin, merge, nodeFetch, common, devCommonConfig, _a, clientConfig, serverConfig, devClientConfig, devServerConfig;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ENV_CONFIG = options.ENV_CONFIG;
                    ModuleFederationPlugin = deps.webpack.container.ModuleFederationPlugin, HtmlWebpackPlugin = deps.HtmlWebpackPlugin, merge = deps.webpackMerge.merge, nodeFetch = deps.nodeFetch;
                    common = (0, webpack_common_1.generateReactCommonConfig)(options, deps);
                    devCommonConfig = merge(common.config, {
                        mode: "development",
                    });
                    return [4 /*yield*/, main_1.Polyfills.fetchNodePolyfill(nodeFetch)];
                case 1:
                    _b.sent();
                    _a = helpers_1.ModuleFederationHelper.buildRemoteModuleFederationConfigs(common.__mfeName__, common.sharedModuleFederationDeps(), ENV_CONFIG), clientConfig = _a.clientConfig, serverConfig = _a.serverConfig;
                    devClientConfig = merge(devCommonConfig, {
                        target: "web",
                        entry: {
                            main: "./src/index",
                        },
                        output: {
                            uniqueName: common.__mfeName__ + "ReactDevClient",
                            path: common.distPath + common.remotePath + "client",
                            publicPath: "".concat(ENV_CONFIG.getRemoteEndpointBy(common.type), ":").concat(common.devClientPort, "/client/"),
                            clean: true,
                        },
                        devServer: {
                            port: common.devClientPort,
                            historyApiFallback: {
                                index: "/client/index.html",
                            },
                            headers: {
                                "Access-Control-Allow-Origin": "*",
                                "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, PATCH, OPTIONS",
                                "Access-Control-Allow-Headers": "X-Requested-With, content-type, Authorization",
                            },
                        },
                        plugins: [
                            new ModuleFederationPlugin(clientConfig),
                            new HtmlWebpackPlugin({
                                template: "./public/index.html",
                            }),
                        ],
                    });
                    devServerConfig = merge(devCommonConfig, {
                        target: "async-node",
                        output: {
                            uniqueName: common.__mfeName__ + "ReactDevServer",
                            path: common.distPath + common.remotePath + "server",
                            publicPath: "".concat(ENV_CONFIG.getRemoteEndpointBy(common.type), ":").concat(common.devServerPort, "/server/"),
                            clean: true,
                            asyncChunks: false,
                        },
                        plugins: [new ModuleFederationPlugin(serverConfig)],
                    });
                    return [2 /*return*/, [devClientConfig, devServerConfig]];
            }
        });
    });
}
exports.generateWebpackDEV = generateWebpackDEV;
